"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconEnvelope = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconEnvelope = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsxs)("svg", _objectSpread(_objectSpread({
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M39.516 14.8068C39.516 14.5097 39.3675 14.2145 39.1205 14.0157L35.8597 11.6444C35.7613 11.5942 35.6629 11.546 35.5626 11.4958L35.5645 5.91572C35.5645 5.37159 35.1207 4.92784 34.5766 4.92784H26.7718C26.7216 4.87767 26.6734 4.82943 26.6734 4.82943L20.3504 0.185229C20.0051 -0.0617429 19.5111 -0.0617429 19.1658 0.185229L13.1881 4.58053C13.0395 4.67894 12.9411 4.77734 12.8909 4.92591L4.93941 4.92784C4.39529 4.92784 3.95153 5.37162 3.95153 5.91573V11.3995C3.90136 11.3995 3.85312 11.4496 3.80296 11.4979L0.39554 14.0178C0.148568 14.2146 0 14.5117 0 14.8089V39.0121C0 39.5562 0.443778 40 0.987887 40H38.5276C39.0717 40 39.5155 39.5562 39.5155 39.0121L39.516 14.8068ZM37.1949 15.0538L35.5645 16.2384V13.8189L37.1949 15.0538ZM19.7582 2.21124L23.4628 4.92792H16.0536L19.7582 2.21124ZM33.5886 6.9037V17.7201L19.7582 27.8963L5.9278 17.7201V6.9037H33.5886ZM3.95203 13.8693V16.2888L2.32162 15.1041L3.95203 13.8693ZM1.97625 38.0221V17.2765L4.14881 18.9069C4.24722 19.0555 4.39579 19.1539 4.59259 19.2523L19.1639 29.9704C19.3607 30.1189 19.5595 30.1672 19.7563 30.1672C19.9531 30.1672 20.1518 30.117 20.3486 29.9704L34.9199 19.2523C35.1167 19.2021 35.2653 19.0555 35.3637 18.9069L37.5401 17.2765V38.0221H1.97625Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M10.8673 12.831H28.6493C29.1934 12.831 29.6372 12.3872 29.6372 11.8431C29.6372 11.299 29.1934 10.8552 28.6493 10.8552H10.8673C10.3232 10.8552 9.87945 11.299 9.87945 11.8431C9.87945 12.3872 10.3232 12.831 10.8673 12.831Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M10.8673 18.2644H28.6493C29.1934 18.2644 29.6372 17.8206 29.6372 17.2765C29.6372 16.7324 29.1934 16.2886 28.6493 16.2886H10.8673C10.3232 16.2886 9.87945 16.7324 9.87945 17.2765C9.87945 17.8206 10.3232 18.2644 10.8673 18.2644Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M23.7099 21.722H15.8068C15.2626 21.722 14.8189 22.1658 14.8189 22.7099C14.8189 23.254 15.2627 23.6978 15.8068 23.6978H23.7099C24.254 23.6978 24.6977 23.254 24.6977 22.7099C24.6977 22.1658 24.254 21.722 23.7099 21.722Z",
      fill: color
    }, void 0)]
  }), void 0);
});